import { useRouter } from 'next/router';
import useRefreshAuth from '@pkg/auth/useRefresh';
import useAuthStore from '@pkg/auth/useStore';
import useDatabase from '@pkg/database/useDatabase';
import useDesignArchived from '@pkg/entities/designs/listeners/useArchived';
import useDesignInvalidated from '@pkg/entities/designs/listeners/useInvalidated';
import useRefreshActivities from '@pkg/entities/library/activities/useRefresh';
import useRefreshProperties from '@pkg/entities/library/properties/useRefresh';
import useRefreshSkills from '@pkg/entities/library/skills/useRefresh';
import useNotifyOrganisations from '@pkg/entities/organisations/useNotify';
import useRefreshTags from '@pkg/entities/tags/useRefresh';
import useNotifyUsers from '@pkg/entities/users/useNotify';
import config from '@/lib/config';

const Listener = () => {
  const database = useDatabase();
  const router = useRouter();

  const me = useAuthStore((state) => state.me);
  const organisation = useAuthStore((state) => state.organisation);

  const handleArchived = useDesignArchived();
  const handleInvalidated = useDesignInvalidated();

  const { refresh: refreshActivities } = useRefreshActivities();
  const { refresh: refreshAuth } = useRefreshAuth();
  const { refresh: refreshProperties } = useRefreshProperties();
  const { refresh: refreshSkills } = useRefreshSkills();
  const { refresh: refreshTags } = useRefreshTags();

  const organisationListeners = [
    {
      event: '.design.archived',
      context: 'organisation',
      callback: handleArchived,
    },
    {
      event: '.design.invalidated',
      context: 'organisation',
      callback: handleInvalidated,
    },
    {
      event: '.library.activities.updated',
      context: 'organisation',
      callback: refreshActivities,
    },
    {
      event: '.library.properties.updated',
      context: 'organisation',
      callback: refreshProperties,
    },
    {
      event: '.library.skills.updated',
      context: 'organisation',
      callback: refreshSkills,
    },
    {
      event: '.library.tags.updated',
      context: 'organisation',
      callback: refreshTags,
    },
    {
      event: '.organisation.logout',
      context: 'organisation',
      callback: () => router.push(config.PATHS.LOGOUT),
    },
    {
      event: '.organisation.updated',
      context: 'organisation',
      callback: refreshAuth,
    },
  ];

  const userListeners = [
    {
      event: '.user.updated',
      context: 'people',
      callback: refreshAuth,
    },
    {
      event: '.user.logout',
      context: 'people',
      callback: () => router.push(config.PATHS.LOGOUT),
    },
    {
      event: '.user.access.updated',
      context: 'people',
      callback: async () => {
        await database.reset();
        // we need a fresh frontegg JWT with new roles
        window?.location.reload();
      },
    },
  ];

  useNotifyOrganisations(organisation?.uuid, organisationListeners);
  useNotifyUsers(me?.id, userListeners);
};

export default Listener;
